import { isNull, pick, some } from 'lodash';
import CryptoJS from 'crypto-js';

export const formatByMask = (data: number | string, mask: string) => {
  if (!data) return;
  const text = String(data);
  const countMaskSymbols = mask.replaceAll('#', '').length;
  const outIteration = Array.from({ length: countMaskSymbols + text.length });
  let [setIndex, textOut] = [0, ''];

  outIteration.forEach((_, index) => {
    const maskSymbol = mask[index] || '';

    if (maskSymbol === '#') {
      textOut += text[setIndex] || '';
      setIndex += 1;
    } else {
      if (!maskSymbol) setIndex += 1;

      textOut += maskSymbol || text[setIndex] || '';
    }
  });

  return textOut;
};

export const displayAddress = (address: any) => {
  const companyAddress = pick(address, ['street', 'city', 'zipCode', 'country']);
  const ownerCompanyAddress = pick(address?.ownerCompany, ['street', 'city', 'zipCode', 'country']);

  const values = Object.values(
    ownerCompanyAddress.hasOwnProperty('street') && !some(ownerCompanyAddress, isNull)
      ? ownerCompanyAddress
      : companyAddress
  ).filter(item => item);

  return values.join(', ') || '-';
};

export const mapBuilder = (array: any = [], key: string = '_id') =>
  array.reduce((memo: any, next: any) => ({ ...memo, [next[key] || next]: next }), {});

export const generateCodeVerifier = () => {
  const codeVerifierLength = 43;
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  let codeVerifier = '';

  for (let i = 0; i < codeVerifierLength; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    codeVerifier += charset.charAt(randomIndex);
  }

  return codeVerifier;
};

export const generateCodeChallenge = (codeVerifier: string) => {
  const hashedCodeVerifier = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);
  const base64UrlEncodedCodeChallenge = hashedCodeVerifier
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return base64UrlEncodedCodeChallenge;
};
